(() => {
  const root = document.getElementById('gp-plant-concierge');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const origin = root.dataset.service;
  if (origin !== 'https://web-production-d2cac.up.railway.app') return;
  const launcher = document.getElementById('gp-concierge-launcher');
  const panel = document.getElementById('gp-concierge-panel');
  const close = document.getElementById('gp-concierge-close');
  const loading = document.getElementById('gp-concierge-loading');
  const holder = document.getElementById('gp-concierge-frame');
  if (!launcher || !panel || !close || !holder || !loading) return;
  const style = document.createElement('style');
  style.textContent = `
#gp-plant-concierge{position:relative;z-index:2147483000;font-family:Arial,'PingFang HK',sans-serif}
html.gp-concierge-active #sweet-help-chat-box{display:none!important}
#gp-concierge-launcher{position:fixed;left:24px;right:auto;bottom:24px;display:flex;align-items:center;justify-content:center;width:60px;height:60px;min-width:60px;min-height:60px;border:1px solid #c9d9bd;border-radius:50%;background:#274734;color:#fafaf0;padding:0;box-shadow:0 4px 20px #132d2833;font:500 14px/1.4 Arial,'PingFang HK',sans-serif;cursor:pointer;-webkit-tap-highlight-color:transparent;transition:background .15s ease,box-shadow .15s ease}
#gp-concierge-launcher:hover{background:#365b42;box-shadow:0 6px 24px #132d2844}
#gp-concierge-launcher .gp-concierge-avatar{display:block;width:36px;height:36px;flex-shrink:0}
#gp-concierge-launcher .gp-concierge-tooltip{position:absolute;left:calc(100% + 12px);top:50%;transform:translate(4px,-50%);padding:9px 12px;border:1px solid #d2ddc8;border-radius:10px;background:#f8f8f2;color:#234636;box-shadow:0 3px 14px #132d281a;white-space:nowrap;opacity:0;visibility:hidden;pointer-events:none;transition:opacity .15s ease,transform .15s ease}
#gp-concierge-launcher:is(:hover,:focus-visible) .gp-concierge-tooltip{opacity:1;visibility:visible;transform:translate(0,-50%)}
#gp-concierge-launcher[aria-expanded="true"] .gp-concierge-tooltip{opacity:0;visibility:hidden}
#gp-concierge-launcher:focus-visible,#gp-concierge-close:focus-visible,#gp-concierge-resize:focus-visible{outline:3px solid #a8bf8c;outline-offset:3px}
#gp-concierge-panel{position:fixed;inset:auto auto 96px 20px;margin:0;padding:0;width:420px;max-width:calc(100vw - 24px);height:min(720px,calc(100dvh - 120px));max-height:none;border:1px solid #d5dfcd;border-radius:18px;background:#f8f8f2;color:#234636;overflow:hidden;box-shadow:0 12px 70px #19372c38;z-index:2147483001}
#gp-concierge-panel[open]{display:flex;flex-direction:column}
#gp-concierge-panel::backdrop{background:#132d2844}
.gp-concierge-bar{display:flex;align-items:center;justify-content:space-between;padding:3px 8px 3px 18px;min-height:42px;background:#e8eddf;font-size:13px;flex-shrink:0}
#gp-concierge-close{display:flex;align-items:center;justify-content:center;width:38px;height:36px;border:0;background:none;color:#234636;font-size:27px;cursor:pointer}
#gp-concierge-resize{display:flex;align-items:center;justify-content:center;gap:5px;min-height:36px;margin-left:auto;margin-right:4px;padding:6px 10px;border:1px solid #cbd6c0;border-radius:6px;background:#f5f7ee;color:#234636;font:500 12px/1.4 Arial,'PingFang HK',sans-serif;white-space:nowrap;cursor:pointer}
#gp-concierge-resize:hover{background:#dce5d2}
@media(min-width:601px){#gp-concierge-panel.gp-concierge-expanded{inset:auto auto 20px 20px;width:min(900px,calc(100vw - 40px));height:calc(100dvh - 40px)}}
#gp-concierge-frame{flex:1;min-height:0}
#gp-concierge-frame iframe{display:block;width:100%;height:100%;border:0;background:#f8f8f2}
#gp-concierge-loading{padding:12px 18px;font-size:12px;line-height:1.6}
#gp-concierge-loading[hidden]{display:none}
#gp-concierge-loading a{display:inline-block;color:#234636;text-decoration:underline;margin-left:8px}
@media(max-width:600px){#gp-concierge-resize{display:none}#gp-concierge-launcher{left:16px;bottom:calc(16px + env(safe-area-inset-bottom,0px));width:56px;height:56px;min-width:56px;min-height:56px}#gp-concierge-panel{inset:0;width:100%;max-width:none;height:100dvh;border:0;border-radius:0}.gp-concierge-bar{padding-top:env(safe-area-inset-top)}}
@media(hover:none){#gp-concierge-launcher:hover:not(:focus-visible) .gp-concierge-tooltip{opacity:0;visibility:hidden}}
@media(prefers-reduced-motion:reduce){#gp-concierge-launcher,#gp-concierge-launcher .gp-concierge-tooltip{transition:none}}
`;
  root.appendChild(style);
  const resize = document.createElement('button');
  resize.type = 'button';
  resize.id = 'gp-concierge-resize';
  resize.setAttribute('aria-controls', panel.id);
  const zh = root.dataset.language?.startsWith('zh');
  function updateResize() {
    const expanded = panel.classList.contains('gp-concierge-expanded');
    resize.textContent = expanded ? (zh ? '還原 ↙' : 'Restore ↙') : (zh ? '放大 ↗' : 'Expand ↗');
    resize.setAttribute('aria-label', expanded ? (zh ? '還原對話窗口' : 'Restore chat window') : (zh ? '放大對話窗口' : 'Expand chat window'));
    resize.setAttribute('aria-pressed', String(expanded));
  }
  resize.addEventListener('click', () => {
    panel.classList.toggle('gp-concierge-expanded');
    updateResize();
  });
  updateResize();
  close.before(resize);
  const key = 'gp-plant-concierge-session-v1';
  let frame; let previousOverflow = '';
  function readToken() {
    try {
      const saved = JSON.parse(localStorage.getItem(key) || 'null');
      if (saved?.expiresAt > Date.now() && /^[a-f0-9]{64}$/.test(saved.token)) return saved.token;
      localStorage.removeItem(key);
    } catch {}
    return '';
  }
  function hide() { panel.close(); }
  panel.addEventListener('close', () => { launcher.setAttribute('aria-expanded', 'false'); document.documentElement.style.overflow = previousOverflow; launcher.focus(); });
  close.addEventListener('click', hide);
  panel.addEventListener('cancel', event => { event.preventDefault(); hide(); });
  const publishedTurns = new Set();
  function loadAnalyticsPermission() {
    try {
      if (!window.Shopify?.customerPrivacy) {
        window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.2' }], () => {});
      }
    } catch { /* Chat remains available when the privacy API cannot load. */ }
  }
  loadAnalyticsPermission();
  function recordUsage(request) {
    const id = request.requestId;
    if (typeof id !== 'string' || !/^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i.test(id) || publishedTurns.has(id)) return;
    // Never queue pre-consent activity or send the conversation token/text to analytics.
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true || !window.Shopify?.analytics?.publish) return;
      publishedTurns.add(id);
      if (publishedTurns.size > 200) publishedTurns.delete(publishedTurns.values().next().value);
      Promise.resolve(window.Shopify.analytics.publish('gp_ai_concierge_used', { requestId: id })).catch(() => {});
    } catch { /* Analytics availability does not affect chat or cart actions. */ }
  }
  const cartRequests = new Map();
  let cartBusy = false;
  const routeRoot = () => {
    const value = window.Shopify?.routes?.root || '/';
    return /^\/(?:[a-zA-Z-]+\/)?$/.test(value) ? value : '/';
  };
  async function refreshCart(result) {
    try {
      const sectionId = document.querySelector('hdt-cart-drawer[ref="hdt-cart"]')?.getAttribute('section-id');
      if (sectionId && result.sections?.[sectionId]) root.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { cartData: result, source: 'plant-concierge', actionAfterATC: 'no_action', data: { sections: result.sections } } }));
      else document.dispatchEvent(new CustomEvent('cart:reload'));
      const response = await fetch(routeRoot() + 'cart.js', { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(8000) });
      if (response.ok) {
        const cart = await response.json();
        if (Number.isSafeInteger(cart.item_count)) document.querySelectorAll('hdt-cart-count').forEach(el => { el.textContent = String(cart.item_count); });
      }
    } catch { /* Addition is already confirmed. Keep the view-cart action available. */ }
  }
  async function addPlant(request) {
    if (cartBusy) return { status: 'failed', error: 'busy' };
    cartBusy = true;
    let submitted = false;
    try {
      const signal = AbortSignal.timeout(20000);
      const base = routeRoot();
      const [productResponse, cartResponse] = await Promise.all([
        fetch(base + 'products/' + request.handle + '.js', { credentials: 'same-origin', cache: 'no-store', signal }),
        fetch(base + 'cart.js', { credentials: 'same-origin', cache: 'no-store', signal }),
      ]);
      if (!productResponse.ok || !cartResponse.ok) return { status: 'failed', error: 'unavailable' };
      const [product, cart] = await Promise.all([productResponse.json(), cartResponse.json()]);
      if (cart.currency !== 'HKD') return { status: 'failed', error: 'currency' };
      const variant = product.variants?.find(item => String(item.id) === request.variantId);
      if (!variant?.available || product.requires_selling_plan) return { status: 'failed', error: 'unavailable' };
      if (variant.price !== request.priceCents) return { status: 'failed', error: 'price_changed' };
      const sectionId = document.querySelector('hdt-cart-drawer[ref="hdt-cart"]')?.getAttribute('section-id');
      const body = { items: [{ id: request.variantId, quantity: request.quantity ?? 1 }], sections_url: location.pathname };
      if (sectionId) body.sections = [sectionId];
      submitted = true;
      const response = await fetch(base + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body), signal });
      const result = await response.json();
      if (response.status === 422) { void refreshCart(result); return { status: 'unknown', error: 'stock_limit' }; }
      if (!response.ok || result.status || !result.items?.some(item => String(item.variant_id ?? item.id) === request.variantId)) return { status: 'unknown' };
      void refreshCart(result);
      return { status: 'added' };
    } catch { return submitted ? { status: 'unknown' } : { status: 'failed', error: 'network' }; }
    finally { cartBusy = false; }
  }
  function handleCart(request) {
    if (typeof request.requestId !== 'string' || !/^[a-f0-9-]{36}$/.test(request.requestId)) return;
    const reply = result => frame?.contentWindow?.postMessage({ type: 'gp-concierge:cart-result', requestId: request.requestId, ...result }, origin);
    if (!cartRequests.has(request.requestId)) {
      if ((request.quantity !== undefined && (!Number.isSafeInteger(request.quantity) || request.quantity < 1 || request.quantity > 99)) || cartRequests.size >= 100 || typeof request.variantId !== 'string' || !/^[1-9]\d{0,15}$/.test(request.variantId) || !Number.isSafeInteger(Number(request.variantId)) || typeof request.handle !== 'string' || !/^[a-z0-9-]{1,200}$/.test(request.handle) || !Number.isSafeInteger(request.priceCents) || request.priceCents < 0) { reply({ status: 'failed', error: 'invalid' }); return; }
      // Replayed messages return the original result, never repeat the add request.
      cartRequests.set(request.requestId, addPlant(request));
    }
    void cartRequests.get(request.requestId).then(reply);
  }
  window.addEventListener('message', event => {
    if (!frame || event.origin !== origin || event.source !== frame.contentWindow) return;
    if (event.data?.type === 'gp-concierge:ready') {
      loading.hidden = true;
      frame.contentWindow.postMessage({ type: 'gp-concierge:init', token: readToken(), cart: true, cartOptions: true }, origin);
    } else if (event.data?.type === 'gp-concierge:session' && /^[a-f0-9]{64}$/.test(event.data.token) && Number.isFinite(event.data.expiresAt)) {
      try { localStorage.setItem(key, JSON.stringify({ token: event.data.token, expiresAt: Math.min(event.data.expiresAt, Date.now() + 604800000) })); } catch {}
    } else if (event.data?.type === 'gp-concierge:used') recordUsage(event.data);
    else if (event.data?.type === 'gp-concierge:cart-add') handleCart(event.data);
    else if (event.data?.type === 'gp-concierge:cart-open') location.assign(routeRoot() + 'cart');
    else if (event.data?.type === 'gp-concierge:close') hide();
  });
  launcher.addEventListener('click', () => {
    if (panel.open) { hide(); return; }
    loadAnalyticsPermission();
    previousOverflow = document.documentElement.style.overflow;
    if (matchMedia('(max-width:600px)').matches) { panel.showModal(); document.documentElement.style.overflow = 'hidden'; } else panel.show();
    launcher.setAttribute('aria-expanded', 'true'); close.focus();
    if (!frame) {
      frame = document.createElement('iframe');
      frame.title = document.getElementById('gp-concierge-title').textContent;
      frame.referrerPolicy = 'origin';
      frame.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-forms');
      frame.src = origin + '/ai-concierge/widget?lang=' + (root.dataset.language?.startsWith('zh') ? 'zh' : 'en');
      holder.appendChild(frame);
    }
  });
  document.documentElement.classList.add('gp-concierge-active');
})();
